module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-ExtraBoldItalic.90b1f78.woff2";